import React, { useState, useEffect } from "react";
import { Provider } from "./LocationContext";

const LocationContextProvider = ({ children }) => {
	const [location, setLocation] = useState();
	useEffect(() => {
		const getLocation = async () => {
			const data = await navigator.permissions.query({ name: "geolocation" });
			console.log(data);
			if (data.state === "granted") {
				console.log("Ya teniamos acceso");
				navigator.geolocation.getCurrentPosition((position) => {
					console.log("aca", position);
					setLocation(position);
				});
			} else if (data.state === "prompt") {
			} else if (data.state === "denied") {
				console.log("Acceso denegado.");
			}
		};
		getLocation();
	}, []);
	return <Provider value>{children}</Provider>;
};

export default LocationContextProvider;
